export const AISearchResultGqlSchema = `
  articleId
  title
  content
  category
  score
`;
